import { mctRequest } from '@/api/axios'

export const alarmQueryAll = <T = any>(data: any): Promise<T> => {
  const config = {
    url: '/alarm/queryAll',
    method: 'post',
    data
  }
  return mctRequest.request<T>(config)
}

export const queryComponent = <T = any>(
  checkIds: any,
  zoneIds: any = 0,
  clusterIds: any = 0
): Promise<T> => {
  const config = {
    url: `/infrastructure/querycomponent/${checkIds}_/${zoneIds}_/${clusterIds}_`
  }
  return mctRequest.request<T>(config)
}

export const refreshstructure = <T = any>(): Promise<T> => {
  const config = {
    url: '/infrastructure/refreshstructure'
  }
  return mctRequest.request<T>(config)
}

export const deleteserver = <T = any>(
  ids: any,
  userName: any,
  reason: any
): Promise<T> => {
  const config = {
    url: `infrastructure/deleteserver/${ids}_/${userName}/${reason}`,
    method: 'post'
  }
  return mctRequest.request<T>(config)
}

export const batchMoveServer = <T = any>(
  ids: any,
  targetZone: any,
  userName: any,
  reason: any
): Promise<T> => {
  const config = {
    url: `/infrastructure/batchMoveServer/${ids}_/${targetZone}/?username=${userName}&reason=${reason}`,
    method: 'post'
  }
  return mctRequest.request<T>(config)
}

export const getZoneList = <T = any>(
  zoneId: any,
  clusterId: any
): Promise<T> => {
  const config = {
    url: `/zone/allSameTypeZone?zoneId=${zoneId}&clusterId=${clusterId}`
  }
  return mctRequest.request<T>(config)
}

export const updateMaintain = <T = any>(
  timeZone: any,
  CommonMaintainList: any,
  onlyRecover: Boolean
): Promise<T> => {
  const config = {
    url: `/maintain/update/int/${timeZone}?batchOperation=1`,
    method: 'post',
    data: { onlyRecover, CommonMaintainList }
  }
  return mctRequest.request<T>(config)
}

export const queryMaintain = <T = any>(
  clusterIds: any,
  zoneIds: any,
  checkIds: any
): Promise<T> => {
  const config = {
    url: `/maintain/query?cids=${clusterIds}&zids=${zoneIds}&sids=${checkIds}`
  }
  return mctRequest.request<T>(config)
}
